module.exports = __webpack_public_path__ + "img/ico-arrow-right-gray.b6df7fa5.svg";